import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=9a9bfe34&scoped=true&"
import script from "./OrderInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=9a9bfe34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9bfe34",
  null
  
)

export default component.exports